import { CCol, CInput, CLabel, CRow } from "@coreui/react";
import React, { useEffect, useState } from "react";
import CommonList from "../crud/CommonList";
// import usersData from "../users/UsersData";
const PaymentBidderDetails = () => {
  const [usersData, setuserData] = useState();
  const [loading, setloading] = useState(true);

  useEffect(() => {
    fetch("User/getCGMFOfficers")
      .then((response) => response.json())
      .then((data) => {
        setloading(false);
        setuserData(data);
      });
  }, []);
  const fields = [
    { key: "EMI" },
    { key: "Date", _style: { width: "40%" } },
    "Goods Status",
    { key: "Due Date ", _style: { width: "20%" } },
    { key: "Amount", _style: { width: "20%" } },
    { key: "Payment status", _style: { width: "20%" } },
  ];
  let additional = (
    <>
      <div>
        <CRow>
          <CCol xl={3}>
            <CLabel>Login Id:</CLabel> <CInput />
          </CCol>
          <CCol xl={3}>
            <CLabel> Company Name:</CLabel> <CInput />
          </CCol>
        </CRow>
        <CRow className="mt-3">
          <CCol xl={3}>
            <CLabel></CLabel>Lot number: <CInput />
          </CCol>
          <CCol xl={3}>
            <CLabel>Purchase Rate per S.B.:</CLabel> <CInput />
          </CCol>
        </CRow>
        <CRow className="mt-3">
          <CCol xl={3}>
            <CLabel>Purchase Price :</CLabel> <CInput />
          </CCol>
        </CRow>
      </div>
    </>
  );
  return (
    <CRow>
      <CCol xl={12}>
        <CommonList
          items={usersData}
          fields={fields}
          listName="Bidder Details"
          loading={loading}
          additional={additional}
        />
      </CCol>
    </CRow>
  );
};
export default PaymentBidderDetails;
